'use client'

import { Checkbox } from '@graftcode/design-system'

import { VIDEOS_TEST_IDS } from '../../videos.const'
import type { AcademyVideoTopic } from '../../videos.interface'

import styles from './VideosTopicsFilter.module.scss'

type VideosTopicsFilterProps = {
  topics: AcademyVideoTopic[]
  selectedTopicIds: string[]
  onTopicToggle: (topicId: string, checked: boolean) => void
  onReset: () => void
}

export function VideosTopicsFilter({ topics, selectedTopicIds, onTopicToggle, onReset }: VideosTopicsFilterProps) {
  const selected = new Set(selectedTopicIds)

  return (
    <aside className={styles.filter} data-testid={VIDEOS_TEST_IDS.topicsFilter}>
      <div className={styles.header}>
        <span className={styles.title}>Topics</span>
        <button type="button" className={styles.reset} onClick={onReset} data-testid={VIDEOS_TEST_IDS.topicsReset}>
          Reset
        </button>
      </div>
      <div className={styles.list}>
        {topics.map((topic) => (
          <label key={topic.id} className={styles.item}>
            <Checkbox checked={selected.has(topic.id)} onChange={(next) => onTopicToggle(topic.id, next === true)} />
            <span className={styles.label}>{topic.label}</span>
          </label>
        ))}
      </div>
    </aside>
  )
}
